import type { IconDef } from '../types';

export const chart: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22.0002 3C21.4502 3 21.0002 3.45 21.0002 4V19.02L18.0002 19.08V7.53C18.0002 6.98 17.5502 6.53 17.0002 6.53C16.4502 6.53 16.0002 6.98 16.0002 7.53V19.11L13.0002 19.17V11.53C13.0002 10.98 12.5502 10.53 12.0002 10.53C11.4502 10.53 11.0002 10.98 11.0002 11.53V19.2L8.00017 19.26V15.53C8.00017 14.98 7.55017 14.53 7.00017 14.53C6.45017 14.53 6.00017 14.98 6.00017 15.53V19.3L1.98017 19.38C1.43017 19.39 0.990167 19.84 1.00017 20.39C1.01017 20.94 1.46017 21.37 2.00017 21.37C2.01017 21.37 2.01017 21.37 2.02017 21.37L22.0202 21C22.5602 20.99 23.0002 20.54 23.0002 20V4C23.0002 3.45 22.5502 3 22.0002 3Z',
    },
  ],
};
